"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NotificationBarWithMessages = _interopRequireDefault(require("../../containers/NotificationBarWithMessages"));

var _actions = require("./../../actions");

var _postMessageHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/post-message-helper"));

var NotificationBarWrapper =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(NotificationBarWrapper, _Component);

  function NotificationBarWrapper(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, NotificationBarWrapper);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(NotificationBarWrapper).call(this, props));
    _this.id = new Date().getTime();
    return _this;
  }

  (0, _createClass2["default"])(NotificationBarWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          dispatch = _this$props.dispatch,
          registerPlaceholder = _this$props.registerPlaceholder,
          targetKey = _this$props.targetKey,
          placeholders = _this$props.placeholders;
      dispatch(registerPlaceholder(targetKey, this.id)); // Register fetch_notification listener on the first notification bar, otherwise it is registered multiple times

      if (placeholders && placeholders.length === 0) {
        this.postMessageHandler = new _postMessageHelper["default"]();
        this.postMessageHandler.bind('fetch_notification', function (data) {
          (0, _actions.showError)(data.message)(dispatch);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          dispatch = _this$props2.dispatch,
          unRegisterPlaceholder = _this$props2.unRegisterPlaceholder;
      dispatch(unRegisterPlaceholder(this.id));

      if (this.postMessageHandler) {
        this.postMessageHandler.clear();
        this.postMessageHandler = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement(_NotificationBarWithMessages["default"], (0, _extends2["default"])({
        id: this.id
      }, this.props));
    }
  }]);
  return NotificationBarWrapper;
}(_react.Component);

NotificationBarWrapper.propTypes = {
  placeholders: _propTypes["default"].array.isRequired,
  registerPlaceholder: _propTypes["default"].func.isRequired,
  unRegisterPlaceholder: _propTypes["default"].func.isRequired,
  targetKey: _propTypes["default"].oneOf(['fullscreen', 'wizard', 'page']),
  dispatch: _propTypes["default"].func
};
NotificationBarWrapper.defaultProps = {
  targetKey: 'fullscreen'
};
var _default = NotificationBarWrapper;
exports["default"] = _default;